import React, { useReducer } from 'react';
import { Header } from './components/Header';
import { Home } from './components/Home';
import { Footer } from './components/Footer';
import { About } from './components/About';
import {   BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Skill } from './components/Skill';
import { Experience } from './components/Experience';
import { ProfileContext } from './state/context';
import { profileReducer } from './state/reducer';
import { initialState } from './state/state';
import { Contact } from './components/Contact';
import { Tech } from './components/Tech';
import './App.css';

function App() {
  const [state, dispatch] = useReducer(profileReducer, initialState);
  return (
    <div className="App">
      <ProfileContext.Provider value={{ state, dispatch }}>
        <Router>
          <Header/>
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/skill" element={<Skill />} />
              <Route path="/experience" element={<Experience />} />
              <Route path="/tech" element={<Tech />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>           
          </main>
          <Footer/>
        </Router>
      </ProfileContext.Provider>
    </div>
  );
}

export default App;
